import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";
import MyDatePicker from './DatePicker';
import { Paper, Button, ClickAwayListener, Box } from '@mui/material';
import { CalendarSearch, X, ArrowRight } from 'lucide-react';
import './DateSelectionStyle.css'

function ProfitLossDateRangePicker({ size = "small", resetDateRangeFilter, ...props }) {
    const classes = useStyles();
    var today = new Date();
    const [open, setOpen] = useState(false);
    const [custom, setCustom] = useState(true);
    const [weekSelected, setWeekSelected] = useState(false);
    const [monthSelected, setMonthSelected] = useState(true);
    const [yearSelected, setYearSelected] = useState(false);
    const [startDate, setStartDate] = useState(props.startDate);
    const [endDate, setEndDate] = useState(props.endDate);

    const handleClickAway = () => {
        setOpen(false);
    };
    useEffect(() => {
        let diff = getNumberOfDays(props.startDate, props.endDate);
        if (props.startDate && sameDay(props.startDate, new Date())) {
            if (diff === 7) {
                setWeekSelected(true);
                setMonthSelected(false);
                setYearSelected(false);
                setCustom(false);
            } else if (diff === 30) {
                setWeekSelected(false);
                setMonthSelected(true);
                setYearSelected(false);
                setCustom(false);
            } else if (diff === 365) {
                setWeekSelected(false);
                setMonthSelected(false);
                setYearSelected(true);
                setCustom(false);
            } else {
                setWeekSelected(false);
                setMonthSelected(false);
                setYearSelected(false);
                setCustom(true);
            }
        } else {
            setWeekSelected(false);
            setMonthSelected(false);
            setYearSelected(false);
            setCustom(true);

        }

    }, [startDate, endDate]);


    function sameDay(d1, d2) {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }

    function getNumberOfDays(start, end) {
        const date1 = new Date(start);
        const date2 = new Date(end);

        // One day in milliseconds
        const oneDay = 1000 * 60 * 60 * 24;

        // Calculating the time difference between two dates
        const diffInTime = date2.getTime() - date1.getTime();

        // Calculating the no. of days between two dates
        const diffInDays = Math.round(diffInTime / oneDay);

        return diffInDays;
    }

    const formatDate = (date) => {
        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, '0'); // Ensure 2 digits for day
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based, add 1
        const year = d.getFullYear(); // Get the full year

        return `${day}/${month}/${year}`; // Return formatted string
    };

    const handleSetStartDate = (event) => {
        if (props.index !== undefined && props.index !== null) {
            props.setDateRange(props.index, new Date(event), new Date(props.endDate), props.sequence);
            props.handleSetStartDate(props.index, event)
        } else {
            props.setDateRange(new Date(event), new Date(props.endDate));
            props.handleSetStartDate(event)
        }

    }

    const handleSetEndDate = (event) => {
        if (props.index !== undefined && props.index !== null) {
            props.setDateRange(props.index, new Date(props.startDate), new Date(event), props.sequence);
            props.handleSetEndDate(props.index, event)
        } else {
            props.setDateRange(new Date(props.startDate), new Date(event), props.sequence);
            props.handleSetEndDate(event)
        }
    }

    const handleOpen = () => {
        setOpen(!open);
    }

    const handleSeven = () => {
        let relevantDays = new Date(today);
        relevantDays.setDate(today.getDate() - 7);
        props.setDateRange(relevantDays, today, props.sequence);
        setWeekSelected(true);
        setYearSelected(false);
        setMonthSelected(false);
        setCustom(false);
    }

    const handleThirty = () => {
        let relevantDays = new Date(today);
        relevantDays.setDate(today.getDate() - 30);
        props.setDateRange(relevantDays, today);
        setMonthSelected(true);
        setYearSelected(false);
        setWeekSelected(false);
        setCustom(false);
    }

    const handleYear = () => {
        let relevantDays = new Date(today);
        relevantDays.setDate(today.getDate() - 365);
        props.setDateRange(relevantDays, today);
        setYearSelected(true);
        setMonthSelected(false);
        setWeekSelected(false);
        setCustom(false);
    }

    const handleCustom = () => {
        setCustom(!custom);
        setMonthSelected(false);
        setWeekSelected(false);
        setYearSelected(false);
    }

    const clearDateRange = (e) => {
        e.stopPropagation();
        setOpen(false);
        resetDateRangeFilter();
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div style={{ display: "inline-block", position: 'relative' }}>

                {/* <IconButton style={{ borderRadius: "5px" }} onClick={handleOpen}>{props.startDate && props.endDate ? props.startDate.toDateString() + " - " + props.endDate.toDateString() : "Select a daterange"}<ChevronDown /></IconButton> */}
                <div
                    onClick={handleOpen}
                    className={classes.dateRangeButton}
                    style={{

                        // fontSize: size === "large" ? "16px" : "14px",
                        paddingLeft: size === "large" ? "12px" : "8px",
                        paddingRight: props.startDate && props.endDate ? "3px" : "8px",
                    }}
                >                    {props.startDate && props.endDate ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <span>
                            {formatDate(props.startDate)}
                        </span>
                        <ArrowRight
                            style={{
                                height: "12px",
                                width: "12px"
                            }}
                        />
                        <span>
                            {formatDate(props.endDate)}

                        </span>

                    </div>
                ) : (
                    <span style={{ opacity: "0.6" }}>Select a date range</span>
                )}
                    {/* {props.startDate && props.endDate ?
                        <button
                            onClick={(e) => clearDateRange(e)}
                            className={classes.clearDateRangeButton}
                            style={{
                                width: size === "large" ? "32px" : "24px",
                                height: size === "large" ? "32px" : "24px",
                            }}
                        >
                            <X
                                className={classes.buttonIcon}
                                style={{
                                    width: size === "large" ? "20px" : "16px",
                                    height: size === "large" ? "20px" : "16px",
                                }}
                            />
                        </button>
                        :
                        <CalendarSearch
                            className={classes.buttonIcon}
                            style={{
                                width: size === "large" ? "20px" : "16px",
                                height: size === "large" ? "20px" : "16px",
                            }}
                        />
                    } */}
                </div>
                {open ?
                    // <Paper elevation={5} style={{ position: "absolute", zIndex: "999", marginTop: "6px" }} >
                    <div className={classes.card}>
                        {/* <div className={classes.buttonContainer}>
                            <button className={clsx(classes.toggleButton, { [classes.selected]: weekSelected })} onClick={handleSeven}>Previous week</button>
                            <button className={clsx(classes.toggleButton, { [classes.selected]: monthSelected })} onClick={handleThirty}>Previous 30 days</button>
                            <button className={clsx(classes.toggleButton, { [classes.selected]: yearSelected })} onClick={handleYear}>Previous year</button>
                            <button className={clsx(classes.toggleButton, { [classes.selected]: custom })} onClick={handleCustom}>Date range</button>
                        </div> */}
                        <div className={classes.inputContainer}>
                            <div className={classes.input}>
                                <label className={classes.label}>From:</label>
                                <MyDatePicker style={{ marginRight: "1rem" }} disabled={!custom} value={props.startDate} toDate={props.endDate} action={handleSetStartDate} />
                            </div>
                            <div className={classes.input}>
                                <label className={classes.label}>To:</label>
                                <MyDatePicker value={props.endDate} disabled={!custom} fromDate={props.startDate} action={handleSetEndDate} />
                            </div>
                        </div>

                    </div>
                    // </Paper>
                    : <React.Fragment></React.Fragment>}
            </div>
        </ClickAwayListener>
    );
}
export default ProfitLossDateRangePicker;

const useStyles = makeStyles((theme) => ({
    card: {
        position: "absolute",
        zIndex: "999",
        width: 'max-content',
        backgroundColor: "white",
        right: "0px",
        border: "1px solid #EDEDED",
        borderRadius: "8px",

        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",

        marginTop: "6px",
        padding: "16px",

        [theme.breakpoints.down('xs')]: {
            left: "0px",
        },
    },

    buttonIcon: {
        width: "16px",
        height: "16px",
        display: "block",

        strokeWidth: "1.4px",
        color: "inherit",
    },

    dateRangeButton: {

        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        borderRadius: "4px",
        // border: "1px solid #DCDCDC",

        // backgroundColor: "white",

        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "#0C0E29",

        "&:hover": {
            cursor: "pointer",
        }
    },

    buttonContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        flexWrap: "wrap",

        marginBottom: "16px",
    },

    toggleButton: {
        height: "40px",
        padding: "0 12px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        position: "relative",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "#a77d4f",
        backgroundColor: "transparent",
        border: "1px solid #a77d4f",

        transition: "all 0.2s ease-in-out",

        userSelect: "none",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        },
    },

    selected: {
        backgroundColor: "#a77d4f", // Style for the "selected" state
        color: "white",
        border: "1px solid #a77d4f", // Add a border for visual indication
    },

    clearDateRangeButton: {
        width: "24px",
        height: "24px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        borderRadius: "2px",
        border: "none",

        backgroundColor: "transparent",
        color: "#0C0E29",

        padding: "0",

        "&:hover": {
            cursor: "pointer",
            color: "#D84949",
            backgroundColor: "#EDEDED",
        }
    },

    inputContainer: {
        display: 'flex',
        gap: '8px',
        flexDirection: 'row',
        justifyContent: 'space-evenly',

        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
        },
    },

    input: {
        display: 'flex',
        flexDirection: 'column',
        width: "50%",

        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
    },

    label: {
        fontSize: "16px",
        color: "rgb(105, 105, 105)",
        marginBottom: "4px",
        textAlign: 'start'
    },

}));